import { render, staticRenderFns } from "./SetServer.vue?vue&type=template&id=2c537ad8"
import script from "./SetServer.vue?vue&type=script&lang=js"
export * from "./SetServer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports